import type { ActionsOfCreators, FeatureHandler } from '../helpers';

import { created } from './created';
import { updated } from './updated';

export const outputActions = [created, updated];

export type OutputActions = ActionsOfCreators<typeof outputActions>;

export type Handler<T extends OutputActions> = FeatureHandler<T, OutputActions>;
